// 各种UA判断
const UA = window.navigator.userAgent
const ua = UA.toLowerCase()
export const isApp = /guazi|ganji|GUAGUA|guagua|Guazi|GUAGUAMobile/i.test(UA)
export const isJianGuaZi = /Guazi\/jianguazi/i.test(UA)
export const isAndroid = /android/i.test(ua)
export const isIOS = /ios|iphone|ipod|ipad/i.test(ua)
export const isWeixin = /micromessenger/i.test(ua)
export const isWeChat = isWeixin
export const isMiui = /miuibrowser|hm|redmi|mi/i.test(ua)
export const isHuaWei = /huawei|honor/i.test(ua)
export const isMobile = /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone|MicroMessenger)/i.test(UA)
export const isMobileUA = (isApp || isJianGuaZi || isAndroid || isIOS || isWeixin || isMobile)
export const platform = isMobileUA ? 'h5' : 'pc' // 平台
